import { useRef } from 'react';
import { useMountEffect } from 'js/hooks/useMountEffect';

// core, added useMountEffect
// Triggers after each render except the first one
export const useUpdateEffect = (cb, deps) => {
    const isFirstRun = useRef(true);

    useMountEffect((isMounted) => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }

        return cb(isMounted);
    }, deps);
};
